import Vue from "vue";
import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_PAYMENT_METHOD](state, payload) {
    state.paymentMethods = payload;
  },
  [MutationsType.SET_PAYMENT_METHODS](state, payload) {
    state.paymentMethods = payload;
  },
  [MutationsType.ADD_PAYMENT_METHOD](state, payload) {
    if (state.paymentMethods) state.paymentMethods.unshift(payload);
  },
  [MutationsType.UPDATE_PAYMENT_METHOD](state, payload) {
    let ind = (state.paymentMethods || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.paymentMethods, ind, payload);
  },
  [MutationsType.DELETE_PAYMENT_METHOD](state, payload) {
    let ind = (state.paymentMethods || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.paymentMethods, ind);
  },
};
